<div class="popup">
    <div class="modal-header" style="text-align:center;">
        <div class="modal-headerTitle" style="padding-left:10px; padding-top:10px; color:red; width:100%;">WARNING</div>
    </div>
    <div class="modal-body" style="padding:10px;margin-bottom:70px;">
        <div style="padding-top:10px; padding-left:10px;padding-right:10px; font-weight:bold;">
            To change Gradebook Preferences, you must be the primary teacher for at least one class open for grading.
        </div>
    </div>    
    <div class="sis-app-footer">
            <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeClick()" style="float:right"></tyl-button>
    </div>
</div>
    

